// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchTokens({ commit }) {
    return get(`/canal/tokens`)
      .then(({ data }) => {
        commit('addTokens', data)
      })
  },
  async fetchTokensPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', name = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(name && { name }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/tokens/page?${queryParams}`);
    commit("addTokensPage", data)
    return data;
  },
  createTokens({ commit }, tokens) {
    return post("/canal/tokens", tokens).then(({ data }) => {
      //commit("addTokens", data);
    });
  },
  updateTokens({ commit }, tokens) {
    return put(`/canal/tokens/edit/${tokens.id}`, tokens).then(({ data }) => {
      //commit("replaceTokens", data);
    });
  },
  createOrUpdateTokens({ dispatch }, tokens) {
    if (tokens.id !== undefined) {
      return dispatch('updateTokens', tokens)
    } else {
      return dispatch('createTokens', tokens)
    }
  },
  selectTokens({ commit }, tokens) {
    commit('setTokens', tokens)
  },
  deleteTokens({ commit }, tokens) {
    return remove(`/canal/tokens/${tokens.id}`)
      .then(({ data }) => { })
  },
}
